import apiClient from './apiClient';
import type {
  AtterbergData,
  AtterbergGeneral,
  AtterbergDetail,
} from '../types/atterberg';

export const getAtterbergData = async (
  workOrderDetailKey: string,
): Promise<AtterbergData> => {
  const response = await apiClient.get<AtterbergData>(
    `/workorderdetails/${workOrderDetailKey}/atterberg`,
  );
  return response.data;
};

export const saveAtterbergData = async (
  workOrderDetailKey: string,
  general: AtterbergGeneral,
  llTrials: AtterbergDetail[],
  plTrials: AtterbergDetail[],
  retestLLTrials: AtterbergDetail[],
  confirmReset = false,
): Promise<AtterbergData & { resetPerformed?: boolean }> => {
  const response = await apiClient.put(`/workorderdetails/${workOrderDetailKey}/atterberg`, {
    general,
    llTrials,
    plTrials,
    retestLLTrials,
    confirmReset,
  });
  return response.data;
};
